<template>
  <div class="bg-white dark:bg-gray-800 shadow overflow-hidden sm:rounded-lg">
    <div class="px-4 py-5 sm:px-6 flex justify-between items-center">
      <div>
        <h3 class="text-lg leading-6 font-medium text-gray-900 dark:text-white">
          Site Dashboard
        </h3>
        <p class="mt-1 max-w-2xl text-sm text-gray-500 dark:text-gray-400">
          Real-time metrics and visualization for {{ site.name }}
        </p>
      </div>
      <a 
        :href="dashboardUrl" 
        target="_blank"
        class="inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 dark:bg-gray-700 dark:text-gray-200 dark:border-gray-600 dark:hover:bg-gray-600"
      >
        Open in Grafana
        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
        </svg>
      </a>
    </div>
    <div class="border-t border-gray-200 dark:border-gray-700">
      <div class="aspect-w-16 aspect-h-9 h-[800px] w-full">
        <iframe
          v-if="dashboardUrl"
          :src="dashboardUrl + '&kiosk'"
          width="100%"
          height="100%"
          frameborder="0"
          class="w-full h-full"
        ></iframe>
        <div v-else class="flex items-center justify-center h-full text-gray-500">
          Dashboard URL not configured
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  site: {
    type: Object,
    required: true
  }
});

// TODO: Replace with actual Grafana URL pattern or configuration
// You might want to move this to a config file or environment variable
const GRAFANA_BASE_URL = 'https://grafana.example.com/d/site-overview/site-overview';

const dashboardUrl = computed(() => {
  if (!props.site) return '';
  
  // Construct URL with query parameters for the specific site
  // Adjust 'var-site' to match your Grafana dashboard variable name
  return `${GRAFANA_BASE_URL}?orgId=1&var-site=${encodeURIComponent(props.site.name)}&refresh=1m`;
});
</script>
